import * as React from 'react';
import Box from '@mui/material/Box';

/**
 * Fades + lifts its children into view the first time they intersect
 * the viewport. Falls back to visible when IntersectionObserver is
 * unavailable, and respects prefers-reduced-motion via index.css.
 */
export default function Reveal({ children, delay = 0, threshold = 0.15, sx }) {
    const ref = React.useRef(null);
    const [visible, setVisible] = React.useState(false);

    React.useEffect(() => {
        const node = ref.current;
        if (!node || typeof IntersectionObserver === 'undefined') {
            setVisible(true);
            return undefined;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold, rootMargin: '0px 0px -8% 0px' }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, [threshold]);

    return (
        <Box
            ref={ref}
            className={`vg-reveal${visible ? ' is-visible' : ''}`}
            sx={{ transitionDelay: `${delay}ms`, ...sx }}
        >
            {children}
        </Box>
    );
}
